module.exports = __webpack_public_path__ + "08b6b451e5bfc23fef59916a7f31a920.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003C67.png
// module id = 1545
// module chunks = 0